import { FilterItem, Filters } from "../shared/context/FilterContext";

export const extractFilterValue = (item: FilterItem | FilterItem[] | any): any => {
  if (!item) return null;
  
  if (Array.isArray(item)) {
    return item.map((i: any) => i?.value ?? i);
  }  
  return item?.value ?? item;
};

export const extractFilterValues = (filterArray: FilterItem[]): string[] | null => {
  if (!filterArray?.length) return null;
  return filterArray.map(f => f.value);
};

export const getFilterValuesForAPI = (filters: Filters) => {
  return {
    programme_id: filters.programme?.length ? filters.programme.map(p => p.value) : null,
    region_id: filters.region?.length ? filters.region.map(r => r.value) : null,
    site_id: filters.site?.length ? filters.site.map(s => s.value) : null,
    stakeholder_id: filters.stakeholder?.length ? filters.stakeholder.map(st => st.value) : null,
    workstream_id: filters.workstream?.length ? filters.workstream.map(w => w.value) : null,
    'worktype_group_id': filters['worktype-group']?.length ? filters['worktype-group'].map(wt => wt.value) : null,
    projectYear: filters.projectYear?.length ? filters.projectYear.map(py => py.value) : null,
  };
};

export const getSimpleFilterValue = (filterArray: FilterItem[]): string | string[] | null => {
  if (!filterArray?.length) return null;
  
  const values = filterArray.map(f => f.value);
  return values.length === 1 ? values[0] : values;
};
